






























































































































































import { Prop, Component, Vue, Watch } from "vue-property-decorator";
import LessonIcon from "@/components/lessons/lessonIcon.vue";
import { Lesson, MyLessons } from "../../types/MyLessons";
import { Getter, Action } from "vuex-class";
import { getExerciseHTML } from "@/library/api";
import { AxiosResponse, AxiosError } from "axios";
import Recorder from "@/components/record/recorder.vue";
import LearnerResults from "@/views/learner/learnerresults.vue";
import { NewResults } from "../../types/NewResults";
import { FillerType } from "../../types/LearnerRecordings";
import consts from "../../consts";
import bodymovin from "lottie-web";
import resultsprocessing from "@/assets/lottiefiles/resultsprocessing.json";
import lessonloading from "@/assets/lottiefiles/lesson-loading.json";
import { MyExercise, Team } from "../../types";
import Parrot from "@/assets/images/parrot/ParrotMicSinging.svg?inline";

import { getDomain } from "@/auth";
import { source, refreshAxiosCancelToken } from "@/store/actions";
import amplitude from "amplitude-js";
// import Iframe from "../../components/editor/Iframe";
let initiator = {
  serverURL: consts.base,
  user: {
    uid: "",
    name: " ",
    jwt: "",
  },
  jwt: "",
  exerciseID: -1,
  lessonID: -1,
  device: {
    OS: "web",
    appVersion: "99",
    amplitudekey: "",
  },
};
@Component({
  components: { LessonIcon, Recorder, LearnerResults, Parrot },
})
export default class ExerciseView extends Vue {
  private lesson!: Lesson;
  private exerciseIndex!: number;
  private myExercise: MyExercise | null = null;
  private results: NewResults | null = null;
  private finishedRecording: boolean = false;
  private timenow = Date.now();
  private exerciseID!: number;
  private recordError: string | null = null;
  private readyToRecord: boolean = false;
  private displayNoMediaAccessError = false;
  private isFailed: boolean = false;
  private iFrame!: HTMLIFrameElement;
  private resetRecorder = Date.now();
  private webviewResults = false;
  private forceShowResults = false;
  private isExerciseLoaded = false;
  // private videoEnabled: boolean | null = null;
  @Getter private lessonByID!: (id: number) => Lesson;
  @Getter private JWT!: string;
  @Getter private UID!: string;
  @Action private fetchMyLessons: any;
  @Getter private myLessons!: MyLessons;
  @Action private fetchUserPlan!: () => any;
  @Getter private userPlan?: any;
  @Getter private teams?: Team[];
  @Getter private doneInitAssessment?: any;

  @Action private resetState: any;
  private $amplitude: any;

  private created() {
    // Setup amplitude
    // source.cancel();
    // let domain = getDomain(window.location.href) as string | undefined;
    // this.$cookies.remove("ORAI_AUTH", "/", domain);
    // this.$cookies.remove(consts.currentLearnerTeam, "/", domain);
    // localStorage.clear();
    // this.resetState();
    // refreshAxiosCancelToken();
    // amplitude.getInstance().init(consts.amplitudeKey, "", {
    //   saveEvents: true,
    //   includeUtm: true,
    //   includeReferrer: true,
    // });
    // this.$amplitude = amplitude.getInstance();

    this.fetchUserPlan();
    const eid = Number(this.$route.params.eid);
    this.exerciseID = eid;
    window.addEventListener("message", this.handleMessage, false);
    this.lesson = this.lessonByID(Number(this.$route.params.lid));
    if (!this.lesson) {
      this.fetchMyLessons();
    } else {
      this.fetchExercise();
    }
  }

  private destroyed() {
    window.removeEventListener("message", this.handleMessage);
  }

  @Watch("myLessons")
  private fetchExercise() {
    this.lesson = this.lessonByID(Number(this.$route.params.lid));
    this.exerciseIndex = this.lesson.Exercises.findIndex(
      (x) => x.ID === this.exerciseID
    );
    this.getHtml(this.exerciseID);
    initiator.user.jwt = this.JWT;
    initiator.jwt = this.JWT; // Need to check if this is being used in somewhere
    initiator.user.uid = this.UID;
    initiator.exerciseID = this.exerciseID;
    initiator.lessonID = this.lesson.ID;
  }
  private onRecordFail(event?: Event) {
    if (event && event.type === "missing-av-permissions") {
      this.recordError =
        "Please enable your microphone and camera access and try again.";
    } else {
      this.recordError =
        "A network or system error has occured. Please try again";
    }
    this.onRecordCancel();
  }

  private onRecordCancel() {
    try {
      (this.iFrame.contentWindow! as any).recordDidStop(false);
    } catch (error) {}
  }

  private handleMessage(ev: MessageEvent) {
    console.warn(ev.data);
    switch (ev.data) {
      case "readyToRecord":
      case "startVideoTrack":
        //console.warn(ev.data);
        this.readyToRecord = true;
        this.finishedRecording = false;
        this.resetRecorder = Date.now();
        this.forceShowResults = false;
        break;
      case "webviewResults":
        this.webviewResults = true;
        break;
      case "skipResults":
      case "exerciseCompletedSuccessfully":
        this.$router.go(-1);
        break;
      case "showResults":
        this.forceShowResults = true;
        break;
      case "stopRecordingAndGetResults":
        let recorder = this.$refs.recorder as Recorder;
        recorder.stopRecording();
        break;
      case "stopRecording":
        this.readyToRecord = false;
        let refRecorder = this.$refs.recorder as Recorder;
        refRecorder.cancelRecording();
        break;
      default:
        // console.warn(ev.data);
        break;
    }
  }

  get isNextExercise() {
    return (
      this.results &&
      this.results.Results &&
      this.exerciseIndex != this.lesson.Exercises.length - 1
    );
  }

  private gotoNextExercise() {
    this.$router.replace({
      name: "exercise",
      params: {
        eid: String(this.lesson.Exercises[this.exerciseIndex + 1].ID),
        lid: String(this.lesson.ID),
      },
    });
    this.resetRecording();
  }

  private getHtml(eid: Number) {
    console.log(eid);
    let iframe = this.$refs.iframe;
    getExerciseHTML(eid).then(
      (response: AxiosResponse) => {
        console.log(response.data);
        this.myExercise = response && response.data;
        // this.websiteHTML = payload;
        // this.videoEnabled = payload.FeedbackOptions.Video;
        this.setIframe(this.myExercise!.RichModuleText);
      },
      (error: AxiosError) => {
        console.error(error);
        this.onRecordFail();
      }
    );
  }
  private resetRecording() {
    window.location.reload();
  }
  private onStartRecording(initiatorResponse: any) {
    this.results = null;
    try {
      (this.iFrame.contentWindow! as any).recordDidStart(initiatorResponse.ID);
    } catch (error) {}
  }
  private onDoneRecording() {
    this.finishedRecording = true;
    try {
      (this.iFrame.contentWindow! as any).recordDidStop(true);
    } catch (error) {}
    console.warn("sending stopRecording message");
  }

  private onRTPace(rtPace: number) {
    try {
      (this.iFrame.contentWindow! as any).setPace(rtPace);
    } catch (error) {}
  }

  private onRTFiller(rtFiller: FillerType) {
    try {
      (this.iFrame.contentWindow! as any).sendFiller(
        rtFiller.Word,
        rtFiller.StartTime,
        rtFiller.EndTime
      );
    } catch (error) {}
  }

  private onResults(myresults: any) {
    this.results = myresults;
    // console.log("onResults");
    // console.log(this.results);
    try {
      (this.iFrame.contentWindow! as any).injectResults(myresults);
    } catch (error) {}
  }
  private lottieInit(el: Element, data: any) {
    bodymovin.loadAnimation({
      container: el,
      renderer: "svg",
      loop: true,
      animationData: data,
    });
    // console.log("lottied init");
  }
  private mounted() {
    let svgContainer = this.$refs.processing as Element;
    this.lottieInit(svgContainer!, resultsprocessing);
    let svgContainer2 = this.$refs.iframeloading as Element;
    this.lottieInit(svgContainer2!, lessonloading);
  }
  private setIframe(data: string) {
    const blobContent = new Blob([data], { type: "text/html" });
    this.iFrame = document.createElement("iframe");
    let iFrame = this.iFrame;
    iFrame.src = URL.createObjectURL(blobContent);
    iFrame.frameBorder = "0";
    iFrame.id = "iframe";
    iFrame.addEventListener("load", () => {
      this.isExerciseLoaded = true;
      let foo: any = iFrame.contentWindow!;
      foo.initiator = initiator;
      // iFrame.style.webkitTransform = "scale(0.9)";
      // iFrame.style.webkitTransformOrigin = "0 0";
      // iFrame.style.scroll
      // .element::-webkit-scrollbar { width: 0 !important }
      iFrame.style.marginRight = "auto";
      iFrame.style.marginLeft = "auto";
      iFrame.height = "100%";
      iFrame.width = "100%";
      // iFrame.style.scrollBehavior = "h";
    });
    // iFrame.style.position = "absolute";
    // iFrame.height = "100vh";
    // String(
    //   (this.$refs.iframeparent as HTMLDivElement).offsetHeight
    // );
    // "100%";
    iFrame.style.marginRight = "auto";
    iFrame.style.marginLeft = "auto";
    // iFrame.marginWidth = "auto";
    // iFrame.marginHeight = "auto";

    (this.$refs.iframeparent as Element).appendChild(iFrame);
  }
}
